module.exports = __webpack_public_path__ + "static/media/YF71_5.88e2acc6.jpg";